import axios from 'axios';

import http from 'utility/fetch';

export const uploadFile = async (file, fileFor) => {
    let uploadedUrl = "";
    try {
        let payload={
            "file": `${fileFor}.${file.type.split("/").pop()}`
        }
        if(file.name){
            payload.filename=file.name;
        }
        const UploadRequest = await http.post("admin/uploadProfilePic",
            payload,
        )
        if (UploadRequest.data.status_code === 200) {
            var formData = new FormData();
            for (let key in UploadRequest.data.response.fields) {
                formData.append(key, UploadRequest.data.response.fields[key]);
            }
            formData.append("file", file);
            await axios.post(UploadRequest.data.response.url, formData);
            uploadedUrl = UploadRequest.data.response.url + '/' + UploadRequest.data.response.fields.key;
            return uploadedUrl;
        }
    }
    catch (e) {
        return undefined;
    }
}
 
export const uploadFileWithName = async (file, fileFor) => {
    let uploadedUrl = "";
    try {
        let payload={
            "file": `${fileFor}.${file.type.split("/").pop()}`
        }
        if(file.name){
            payload.filename=file.name;
        }
        const UploadRequest = await http.post("admin/uploadProfilePic",
            payload,
        )
        if (UploadRequest.data.status_code === 200) {
            var formData = new FormData();
            for (let key in UploadRequest.data.response.fields) {
                formData.append(key, UploadRequest.data.response.fields[key]);
            }
            formData.append("file", file);
            await axios.post(UploadRequest.data.response.url, formData);
            uploadedUrl = UploadRequest.data.response.url + '/' + UploadRequest.data.response.fields.key;
            return {url:uploadedUrl,filename:file.name};
        }
    }
    catch (e) {
        return undefined;
    }
}

export const caratUploadFile = async (file, fileFor) => {
    let uploadedUrl = "";
    try {
        let payload={
            "file": `${fileFor}.${file.type.split("/").pop()}`
        }
        if(file.name){
            payload.filename=file.name;
        }
        const UploadRequest = await http.post("admin/uploadPRJZfiles",
            payload,
        )
        if (UploadRequest.data.status_code === 200) {
            var formData = new FormData();
            for (let key in UploadRequest.data.response.fields) {
                formData.append(key, UploadRequest.data.response.fields[key]);
            }
            formData.append("file", file);
            await axios.post(UploadRequest.data.response.url, formData);
            uploadedUrl = UploadRequest.data.response.url + '/' + UploadRequest.data.response.fields.key;
            return uploadedUrl;
        }
    }
    catch (e) {
        return undefined;
    }
}
 